<image-cropper
  #imageCropper
  [imageBase64]="initialImageBase64"
  [imageChangedEvent]="imageChangedEvent"
  [maintainAspectRatio]="maintainAspectRatio"
  [aspectRatio]="aspectRatio"
  format="png"
  (imageCropped)="imageCropped($event)"
  (imageLoaded)="imageLoaded($event)"
  (cropperReady)="cropperReady()"
  (loadImageFailed)="loadImageFailed()"></image-cropper>
